export default {
  page_title: 'Reservations',
  page_description: 'Manage resource reservations',
  add_reservation: 'Add Reservation',
  edit_reservation: 'Edit Reservation',
  editTitle: 'Edit Reservation',
  editSubtitle: 'Update reservation information',
  resource: 'Resource',
  user: 'User',
  start_time: 'Start Time',
  end_time: 'End Time',
  from_date: 'From Date',
  until_date: 'Until Date',
  reserved_from: 'Reserved From',
  reserved_until: 'Reserved Until',
  status: 'Status',
  notes: 'Notes',
  notes_placeholder: 'Enter any notes about this reservation...',
  reserve: 'Reserve',
  from_date_past: 'Reservation start date cannot be in the past',
  until_date_invalid: 'Reservation end date must be after start date',
  create: 'Create',
  edit: 'Edit',
  cancel: 'Cancel Reservation',
  created_successfully: 'Reservation created successfully',
  updated_successfully: 'Reservation updated successfully',
  cancelled_successfully: 'Reservation cancelled successfully',
  invalid_time_range: 'End time must be after start time',
  pending: 'Pending',
  active: 'In progress',
  upcoming: 'Upcoming',
  past: 'Past',
  completed: 'Completed',
  cancelled: 'Cancelled',
  unknown_resource: 'Unknown Resource',
  unknown_user: 'Unknown User',
  overdue: 'Overdue',
  listView: 'List View',
  calendarView: 'Calendar View'
};
